import { createMiddleware, EventsMap } from 'redux-beacon'
import { checkNewRelicOnWindow } from '@chegg-wt/core/utils/newRelic'
import { ActionTypes as CitationActionTypes } from '@chegg-wt/core/state/citation/constants'
import { ActionTypes as UserActionTypes } from '@chegg-wt/core/state/user/constants'
import {
  citationCreatedEvent,
  userAuthEvent,
  softLoginDetectedEvent,
  NewRelicPageEvent,
} from './definitions'

export const newRelicEventEmitter = (events: Array<NewRelicPageEvent>): void => {
  if (checkNewRelicOnWindow()) {
    events.forEach(({ name, attrs, skip = false }) => {
      if (!skip) {
        window.newrelic.addPageAction(name, attrs)
      }
    })
  }
}

export const eventsMap: EventsMap = {
  [CitationActionTypes.CITATION_CREATE_SUCCEEDED]: citationCreatedEvent,
  [UserActionTypes.FETCH_USER]: userAuthEvent,
  [UserActionTypes.REFRESH_AND_FETCH]: softLoginDetectedEvent,
}

export const newRelicMiddleware = createMiddleware(eventsMap, newRelicEventEmitter)
